import {
  type ApiClientResponse,
  type CommonCursorPaginationRailsParams,
  type SortRailsParams,
  apiClient,
  routes,
} from 'common/services';
import type { PaginatedRailsDataObjects, VideoListItemDataObject } from 'models/service';
import type { VideoScope, VideoStatus } from '../models';

type VideoListRequest = {
  featured?: boolean;
  // eslint-disable-next-line @typescript-eslint/naming-convention -- Keys are defined by Backend API endpoint
  organization_id?: string;
  scope?: VideoScope;
  status?: VideoStatus;
} & CommonCursorPaginationRailsParams &
  SortRailsParams<'created_at' | 'name'>;

export const getVideos = async ({ params }: { params: VideoListRequest }) =>
  apiClient.get<
    PaginatedRailsDataObjects<VideoListItemDataObject>,
    ApiClientResponse<PaginatedRailsDataObjects<VideoListItemDataObject>>
  >(routes.videos.find, {
    params,
  });
